// src/components/Navbar.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './NavBar.css'; // ✅ CSS sınıflarını kullanabilmek için



const Navbar = ({ username }) => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false); // 🔧 mobil menü durumu
  const location = useLocation();
  const [showDropdown, setShowDropdown] = useState(false);

  const isPanelPage = location.pathname === '/panel';

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.user-menu')) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleAccountOption = (option) => {
    setShowDropdown(false);
    if (option === 'contact') {
      document.dispatchEvent(new CustomEvent('openContactModal'));
    } else if (option === 'username') {
      document.dispatchEvent(new CustomEvent('openUsernameModal'));
    } else if (option === 'password') {
      document.dispatchEvent(new CustomEvent('openPasswordModal'));
    }
  };

  return (
    <nav className="navbar">

      {/* Logo */}
      <div
        onClick={() => navigate('/')}
        style={{
          fontSize: '1.6rem',
          fontWeight: '700',
          fontFamily: `'Segoe UI', 'Montserrat', 'Poppins', sans-serif`,
          letterSpacing: '1px',
          color: 'white',
          cursor: 'pointer',
          userSelect: 'none'
        }}
      >
        HVAC<span style={{ fontStyle: 'italic', fontWeight: '400' }}> - ASSIST</span>
      </div>

<div className="hamburger" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
  ☰
</div>

      {/* Sağ taraftaki butonlar */}
      <div className={`navbar-right ${mobileMenuOpen ? 'open' : ''}`}>
        {username === 'Ziyaretçi' && (
          <>
           {/* Cihaz Seçimi */}
<button onClick={() => navigate('/tasarim')} style={{
  ...navBtnStyle,
  backgroundColor: '#2563eb'
}}>
  Klima Santrali
</button>
<button onClick={() => navigate('/igk-secim')} style={{
  ...navBtnStyle,
  backgroundColor: '#10b981'
}}>
  IGK Cihazı
</button>
<button onClick={() => navigate('/vrf')} style={{
  ...navBtnStyle,
  backgroundColor: '#8b5cf6'
}}>
  VRF / VRV
</button>
<button onClick={() => navigate('/fan-secim')} style={{
  ...navBtnStyle,
  backgroundColor: '#f97316'
}}>
  Fan Grubu
</button>

          </>
        )}

          {/* İletişim Sayfası */}
            <button onClick={() => navigate('/iletisim')} style={{
              background: 'none',
              color: '#cbd5e1',
              border: 'none',
              fontSize: '0.98rem',
              textDecoration: 'underline',
              cursor: 'pointer',
              padding: '4px 6px',
              fontWeight: '500',
            }}>
              İletişim
            </button>

<button
  onClick={() => navigate('/blog')}
  className="blog-nav-btn"
  style={{
    backgroundColor: 'white',
    color: '#2563eb',
    fontWeight: '600',
    border: '2px solid #2563eb',
    padding: '8px 14px',
    borderRadius: 8,
    marginRight: 10,
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    fontSize: '0.95rem',
  }}
>
  <span role="img" aria-label="book">📚</span> HVAC Blog
</button>

        {username !== 'Ziyaretçi' ? (
          <div className="user-menu" style={{ position: 'relative' }}>
            <div
              onClick={() => setShowDropdown(prev => !prev)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                backgroundColor: '#f1f5f9',
                color: '#0f172a',
                padding: '8px 16px',
                borderRadius: 30,
                border: '1px solid #cbd5e1',
                boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                fontWeight: '600',
                fontSize: '1rem',
                cursor: 'pointer',
                userSelect: 'none'
              }}
            >
              👤 {username}
              <span style={{ fontSize: '1.2rem' }}>▼</span>
            </div>

            {showDropdown && (
              <div style={{
                position: 'absolute',
                top: '110%',
                right: 0,
                backgroundColor: '#fff',
                borderRadius: 10,
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                overflow: 'hidden',
                zIndex: 200,
                minWidth: 240
              }}>
                {isPanelPage ? (
                  <>
                    <button onClick={() => handleAccountOption('contact')} style={dropdownBtnStyle}>📇 İletişim Bilgilerimi Ekle</button>
                    <button onClick={() => handleAccountOption('username')} style={dropdownBtnStyle}>✏️ Kullanıcı Adı Değiştir</button>
                    <button onClick={() => handleAccountOption('password')} style={dropdownBtnStyle}>🔑 Şifre Değiştir</button>
                  </>
                ) : (
                 <button
  onClick={() => {
    const shouldAskBeforePanel = ['/tasarim', '/igk-secim', '/vrf', '/fan'].includes(location.pathname);
    if (shouldAskBeforePanel) {
      const confirmed = window.confirm("Yapılan Değişiklikler Kaydedilmedi. Panele dönmek istiyor musunuz?");
      if (confirmed) {
        navigate('/panel');
      }
    } else {
      navigate('/panel');
    }
  }}
  style={dropdownBtnStyle}
>
  🧾 Panele Dön
</button>

                )}
                <button
                  onClick={() => {
                    localStorage.removeItem('token');
                    navigate('/giris');
                  }}
                  style={{ ...dropdownBtnStyle, backgroundColor: '#ef4444', color: 'white' }}
                >
                  🚪 Çıkış Yap
                </button>
              </div>
            )}
          </div>
        ) : (
          <>
            {/* Giriş / Kayıt */}
            <button onClick={() => navigate('/giris')} style={{
              ...navBtnStyle,
              backgroundColor: '#1e40af',
              padding: '8px 14px',
              fontSize: '0.92rem'
            }}>
              Giriş Yap
            </button>
            <button onClick={() => navigate('/kayit')} style={{
              ...navBtnStyle,
              backgroundColor: '#4338ca',
              padding: '8px 14px',
              fontSize: '0.92rem'
            }}>
              Kayıt Ol
            </button>
          </>
        )}
      </div>
    </nav>
  );
};

const navBtnStyle = {
  color: 'white',
  border: 'none',
  padding: '10px 18px',
  borderRadius: 8,
  fontWeight: '600',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease',
};

const dropdownBtnStyle = {
  display: 'block',
  width: '100%',
  padding: '10px 15px',
  backgroundColor: '#f7f7f7',
  color: '#333',
  fontSize: '0.95rem',
  border: 'none',
  textAlign: 'left',
  cursor: 'pointer',
  borderBottom: '1px solid #eee',
};

export default Navbar;
